/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { PersonProps } from 'Components/common/components/PeopleCardLarge';
import DropWrapper from 'Components/people/components/DropWrapper';
import { useSelector } from 'react-redux';
import { selectGroupCategory } from 'Selector/UISelector';
import styled from 'styled-components';
import {
  greyColorSecondary,
  maxMobile,
  maxTablet,
  minStandardScreen,
  minWidthApp,
  primaryFont,
  primaryHeadingColor,
  secondaryFont, white, wLight, wMBold, wMedium,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  border-radius: 12px;
  background-color: ${white};
  box-shadow: 0px 0px 16.724px -1.967px rgba(0, 0, 0, 0.04);
  width: 100%;
  position: relative;
  @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
    &,
    &.availDrop{
      .layout{
        border-radius: 7px;
      }
    }
  }
  .layout{
    display: none;
  }
  &.availDrop{
    z-index: 4 !important;
    .layout{
      display: flex;
      position: absolute;
      inset: 0;
      height: 100%;
      width: 100%;
      border-radius: 12px;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
    }
  }
  .drop-person-area {
    display: flex;
    flex: 1;
    width: 100%;
  }
  .contentWrapperComponent,
  .emptyContentWrapperComponent{
    display: flex;
    width: 100%;
  }
  .contentWrapperComponent{
    padding: 16px 4px;
    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
      padding: 10px 4px;
    }
  }
  .emptyContentWrapperComponent{
    margin: 10px;
    border: 1px dashed #CFCFCF;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
      margin: 8px;
    }
    .placeholderText{
      color: ${greyColorSecondary};
      text-align: center;
      font-family: ${primaryFont};
      font-size: 16px;
      font-style: normal;
      font-weight: ${wMedium};
      line-height: 18px;
      letter-spacing: -0.369px;
      @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
        font-size: 14px;
      }
    }
  }
  .content{
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    height: 100%;
    width: 100%;
    overflow: auto;
    padding: 0px 22px; // exclude 4px padding + scroll width
    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
      padding: 0 8px;
    }
    &::-webkit-scrollbar {
      width: 6px;
      @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
        width: 5px;
      }
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #D9D9D9;
      border-radius: 12px;
    }
    .infinite-scroll-component__outerdiv {
      width: 100%;
      .infinite-scroll-component {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 14px;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          gap: 12px 4px;
        }
        @media all and (max-width: ${maxTablet}){
          gap: 10px 0px;
        }
        @media all and (max-width: ${maxMobile}){
          gap: 8px 0px;
        }
        width: 100%;
        .person-skeleton-loader,
        .gutter-row{
          max-height: 142px;
          min-height: 142px;
          max-width: calc(50% - 7px);
          min-width: calc(50% - 7px);
          @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
            max-height: 116px;
            min-height: 116px;
            max-width: calc(50% - 4px);
            min-width: calc(50% - 4px);
          }
          @media all and (max-width: ${maxTablet}){
            max-height: 112px;
            min-height: 112px;
          }
          @media all and (max-width: ${maxMobile}){
            max-height: 114px;
            min-height: 114px;
          }
        }
        .person-skeleton-loader {
          margin: 0;
          flex: 1;
          padding: 0 25px;
          .person-skeleton-wrapper{
            .person-box{
              @media all and (max-width: ${maxTablet}){
                width: 50px; 
                min-width: 50px;
                height: 50px;
              }
            }
            .badge-box{
              height: 16px;
              width: 80px;
              @media all and (max-width: ${maxTablet}){
                width: 55px;
                height: 12px;
                margin-top: -14px;
              }
            }
            .title-box{
              display: none;
            }
            .title-box-short{
              height: 16px;
              width: 110px;
              margin-bottom: 0;
              margin-top: 6px;
              @media all and (max-width: ${maxTablet}){
                width: 80px;
                height: 12px;
              }
            }
          }
        }
        .gutter-row{
          overflow: hidden;
          padding: 10px 6px 7px 6px;
          @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
            padding: 5.5px 4px 2px 5.5px;
          }
          & > div{
            width: 100%;
          }
          .person-item{
            margin: 0;
            width: 100%;
            &::before{
              height: calc(100% + 10px);
              transform: translateY(-10px);
              @media screen and (max-width: ${maxMobile}) {
                width: calc(100% + 10px);
                transform: translate(-10px, -10px);
              }
            }
            .person-item-inner-div{
              .person-item-widget{
                margin: 0;
                margin-bottom: 6px;
                @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                  height: 55px;
                  width: 52px;
                  min-width: 52px;
                }
                .holo-svg{
                  display: none;
                }
                .image-wrap-placeholder{
                  height: 100%;
                  width: 100%;
                  min-width: 100%;
                  transform: translate(-50%, -50%);
                  padding: 2px;
                  .person-image-holder{
                    height: 100%;
                    width: 100%;
                    margin: 0;
                  }
                }
                .ant-checkbox-wrapper{
                  margin: 0;
                  .ant-checkbox {
                    right: unset;
                    left: 100%;
                    top: -2px;
                    .ant-checkbox-inner {
                      height: 20px;
                      width: 20px;
                      @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                        height: 16px;
                        width: 16px;
                      }
                      &::after{
                        left: 50%;
                        transform: translate(-50%, -50%) scale(0.75) rotate(45deg);
                      }
                    }
                  }
                }
                .name-wrapper{
                  bottom: 0;
                  transform: translate(-50%, 30%);
                  min-width: unset;
                  height: 18px;
                  padding: 0 10px;
                  @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                    height: 16px;
                    padding: 0 8.75px;
                  }
                  h4{
                    color: ${white};
                    text-align: center;
                    font-family: ${primaryFont};
                    font-size: 12px !important;
                    font-style: normal;
                    font-weight: ${wMedium};
                    line-height: 18px;
                    letter-spacing: -0.245px;
                    margin: 0;
                    padding: 0;
                    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                      font-size: 10px !important;
                      line-height: 16px;
                      letter-spacing: -0.214px;
                      padding: 0 !important;
                      margin: 0 !important;
                    }
                  }
                  .anticon-arrow-right{
                    display: none;
                  }
                }
              }
            }
            .below-card-detail{
              & > span{
                width: 100%;
                & > div {
                  .person-name-here{
                    color: ${primaryHeadingColor} !important;
                    text-align: center;
                    font-family: ${secondaryFont};
                    font-size: 16px;
                    font-style: normal;
                    font-weight: ${wMBold};
                    line-height: 18px;
                    letter-spacing: -0.224px;
                    margin-bottom: 4px;
                    padding: 0;
                    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                      font-size: 14px !important;
                      line-height: 15.746px;
                      letter-spacing: -0.196px;
                      margin-bottom: 2px;
                    }
                    @media all and (max-width: ${maxTablet}){
                      font-size: 12px;
                    }
                  }
                }
              }
              .person-tag-here{
                color: ${greyColorSecondary} !important;
                text-align: center;
                font-family: ${primaryFont};
                font-size: 14px;
                font-style: normal;
                font-weight: ${wLight};
                line-height: 16px;
                letter-spacing: -0.154px;
                margin-bottom: 0;
                padding: 0;
                margin-bottom: 4px !important;
                min-height: unset;
                @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                  font-size: 12px !important;
                  line-height: 13.997px;
                  letter-spacing: -0.135px;
                  margin-bottom: 2px !important;
                }
                @media all and (max-width: ${maxTablet}){
                  font-size: 11px !important;
                }
                &.text-truncate-two-line{
                  -webkit-line-clamp: 1;
                }
              }
              .person-company-here{
                color:  ${greyColorSecondary} !important;
                text-align: center;
                font-family: ${primaryFont};
                font-size: 12px;
                font-style: normal;
                font-weight: ${wMedium};
                line-height: 14px;
                letter-spacing: -0.154px;
                margin-bottom: 0;
                min-height: unset;
                @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
                  letter-spacing: -0.135px;
                }
                @media all and (max-width: ${maxTablet}){
                  font-size: 11px !important;
                }
              }
            }
          }
        }
      }
    }
    .drawerAction {
      left: 100%;
      top: -2px;
      .messageIcon{
        height: 20px;
        width: 20px;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          height: 16px;
          width: 16px;
        }
        svg{
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          height: 11px;
          width: 11px;
          @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
            height: 8.5px;
            width: 8.5px;
          }
        }
      }
    }
  }
`;

type Props = {
  scrollId: string,
  className?: string,
  children: React.ReactNode,
  isEmpty: boolean
  categoryData: {
    stage: string,
    category: string,
    addReasonPopup: (a: PersonProps, b: string, c: string) => void
  }
} & typeof defaultProps;

const defaultProps = {
  className: '',
};

const GridContentBox = function GridContentBox(props: Props) {
  const {
    scrollId,
    className,
    children,
    isEmpty,
    categoryData,
  } = props;
  const dragGroupCategory = useSelector(selectGroupCategory);

  const isDragFlag = (category: string, stage: string) => {
    if (category === dragGroupCategory?.category && stage === dragGroupCategory?.stage) {
      return 'availDrop';
    }
    return '';
  };

  return (
    <Wrapper className={`${className} buyers-category ${isDragFlag(categoryData.category, categoryData.stage)}`}>
      <>
        <div className="layout" />
        <DropWrapper
          groupCategory={categoryData.category}
          groupStage={categoryData.stage}
          addReasonPopup={categoryData.addReasonPopup}
        >
          {!isEmpty ? (
            <div className="contentWrapperComponent">
              <div className="content" id={scrollId}>
                {children}
              </div>
            </div>
          )
            : (
              <div className="emptyContentWrapperComponent">
                <p className="placeholderText">Drag and Drop Buyers here</p>
              </div>
            )}
        </DropWrapper>
      </>
    </Wrapper>
  );
};

GridContentBox.defaultProps = defaultProps;
export default GridContentBox;
